<template>
  <div class="drop__toggle LKRoadmapsFeedTreeToggle">
    <IconToggle
      :style="node.isLast && 'opacity: 0'"
      :loading="node.loading"
      :active="node.isActive"
      class="drop__arrow"
    />

    <div
      class="text-h4"
    >
      <span>
        {{ node.data.name }}
        <IconCount
          v-if="node.data.events_unread_count"
          :count="node.data.events_unread_count"
        />
      </span>
      <div class="text-sm mod--status-attention-card">
        <LKRoadmapsFeedTitleStatuses
          :node-data="node.data"
        />
      </div>
    </div>
  </div>
</template>

<script>
import IconToggle from '@/components/lk/icons/LKIconToggle.vue'
import IconCount from '@/components/lk/icons/LKIconCount.vue'
import LKRoadmapsFeedTitleStatuses from '../ui/LKRoadmapsFeedTitleStatuses.vue'


export default {
  name: 'LKRoadmapsFeedTreeAteDropToggle',
  components: {
    IconToggle,
    IconCount,
    LKRoadmapsFeedTitleStatuses,
  },
  props: {
    node: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style lang="scss">
.LKRoadmapsFeedTreeToggle {
  position: relative;
}
</style>
